import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_cslc_workstojury,
  req_downloadfile_cslc_myparticipant,
  req_edit_cslc_myparticipant,
} from "../../api";
import { DEFAULT_IMAGE_URL, API_BASE } from "../../utils/contrains";
import { Button, Input, Image, Collapse, BackTop, Modal } from "antd";
import "./jury-all-works-list.css";
import OutFileModal from "./out-file-modal";
import PrintFileModal from "./print-file-modal";
import storageUtils from "../../utils/storageUtils";
const { Panel } = Collapse;

class ManagerChoiceWorksList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    uploadStatus: "FINISH",
    choiceStatus: "",
    enrollCode: "",
    isPdfWorkModal: false,
    isPrintWorkModal: false,
  };

  componentDidMount() {
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    const { uploadStatus, choiceStatus, enrollCode } = this.state;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_list_cslc_workstojury(
      userLevel,
      userCode,
      uploadStatus,
      choiceStatus,
      enrollCode,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const items = data;

      this.setState({ items });
      // console.log(items);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  api_downloadfile_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const fileUrl = await req_downloadfile_cslc_myparticipant(
      userLevel,
      userCode,
      "",
      "YES",
      "",
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "入選人員清單";
    a.click();
  };

  api_edit_item = async (item) => {
    await req_edit_cslc_myparticipant(item, storageUtils.getUser().token);
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "VIEW":
        this.setState({ isPdfWorkModal: true, item });
        break;
      case "PRINT":
        this.setState({ isPrintWorkModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_choice_item = (nowSelectedStatus, item) => {
    const { items } = this.state;
    const { Uid } = item;

    // console.log("Uid", Uid);
    const objIndex = items.findIndex((obj) => obj.Uid === Uid);
    const newSelectedStatus = nowSelectedStatus === "NO" ? "YES" : "NO";
    items[objIndex].PrimaryElection = newSelectedStatus;
    // 改變狀態
    this.setState(items);
    // 回寫數據
    const tagertItem = {
      condition: "SELECTED",
      Uid: Uid,
      PrimaryElection: newSelectedStatus,
    };
    this.api_edit_item(tagertItem);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  imgToBase64 = (name) => {
    const img = document.getElementById(name);
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      var canvas = document.createElement;
      var ctx = canvas.getContext("2D");
      canvas.height = this.naturalHeight;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      var data = canvas.toDataURL("image/jpeg");
      console.log("data", data);
    };
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      enrollCode,
      loading,
      item,
      items,
      isPdfWorkModal,
      isPrintWorkModal,
    } = this.state;
    return (
      <>
        <div style={{ marginBottom: "4px" }}>
          <Input
            placeholder="學號"
            style={{
              width: 100,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={enrollCode}
            onChange={(event) =>
              this.setState({ enrollCode: event.target.value })
            }
          />
          <Button type="primary" onClick={() => this.api_list_items()}>
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </Button>{" "}
          <Button type="primary" onClick={() => this.handle_data_download()}>
            <i className="fas fa-cloud-download-alt"></i>
            <span style={{ marginLeft: "4px" }}> 下載入選作品清單</span>
          </Button>
        </div>
        {loading ? (
          <div className="container">
            <div className="text-center">
              <button
                className="btn btn-light text-dark"
                type="button"
                disabled
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>{" "}
                查詢中 ......
              </button>
            </div>
          </div>
        ) : (
          <>
            {" "}
            <div className="container">
              <div className="row">
                {items.map((item, index) => {
                  return (
                    <div
                      className="col-md-3"
                      key={index}
                      style={{ marginBottom: "6px" }}
                    >
                      <div className="titleMame">
                        <button
                          type="button"
                          className={
                            item.PrimaryElection === "YES"
                              ? "btn btn-success btn-sm"
                              : "btn btn-light btn-sm"
                          }
                          style={{ margin: "4px" }}
                          onClick={() =>
                            this.handle_choice_item(item.PrimaryElection, item)
                          }
                        >
                          {item.PrimaryElection === "YES" ? (
                            <i className="fa fa-check"></i>
                          ) : (
                            <i className="fa fa-hand-pointer"></i>
                          )}

                          <span style={{ marginLeft: "4px" }}>
                            {item.PrimaryElection === "YES" ? "入選" : "待選"}
                          </span>
                        </button>
                        <span style={{ fontSize: "14px", marginLeft: "4px" }}>
                          {item.EnrollName}({item.EnrollCode})
                        </span>
                      </div>
                      <div className="thumbnail colstyle" key={index}>
                        <div className="caption">
                          <Collapse accordion>
                            <Panel header="角色名稱" key="1">
                              <p>{item.Title}</p>
                            </Panel>
                            <Panel header="創作理念" key="2">
                              <p>{item.Description}</p>
                            </Panel>
                            <Panel header="團隊成員" key="3">
                              <p>{item.Teams}</p>
                            </Panel>
                            <Panel header="聯絡資訊" key="4">
                              <table width={"100%"}>
                                <tr style={{ backgroundColor: "white" }}>
                                  <td>
                                    <i
                                      className="fa fa-user-circle"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactPerson}
                                    <br />
                                    <i
                                      className="fa fa-phone"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactPhone}
                                    <br />
                                    <i
                                      className="fa fa-envelope-open"
                                      style={{ marginRight: "4px" }}
                                    ></i>
                                    {item.ContactEmail}
                                  </td>
                                </tr>
                              </table>
                            </Panel>
                          </Collapse>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <Image
                            width={"124px"}
                            height={"80px"}
                            src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                          />
                          <Image
                            width={"124px"}
                            height={"80px"}
                            src={DEFAULT_IMAGE_URL + item.AttachedfileB}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <Modal
              destroyOnClose={true}
              visible={isPdfWorkModal}
              onOk={() => {
                this.setState({ isPdfWorkModal: false });
              }}
              okText={"關閉"}
              onCancel={() => {
                this.setState({ isPdfWorkModal: false });
              }}
              cancelButtonProps={{ style: { display: "none" } }}
            >
              <OutFileModal item={item} />
            </Modal>
            <Modal
              destroyOnClose={true}
              visible={isPrintWorkModal}
              onOk={() => {
                this.setState({ isPrintWorkModal: false });
              }}
              okText={"關閉"}
              onCancel={() => {
                this.setState({ isPrintWorkModal: false });
              }}
              cancelButtonProps={{ style: { display: "none" } }}
            >
              <PrintFileModal item={item} />
            </Modal>
            <BackTop>
              <div className="goTop">UP</div>
            </BackTop>
          </>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManagerChoiceWorksList);
